import _ from 'lodash';
import {
  STAKE_SETTINGS,
  STAKE_DETAILS,
  STAKE_SEND,
  STAKE_SUCCESS,
  UNSTAKE_SETTINGS,
  UNSTAKE_INFORMATION,
  UNSTAKE_DETAILS,
  UNSTAKE_SEND,
  UNSTAKE_SUCCESS,
  WITHDRAW_DETAILS,
  WITHDRAW_SEND,
  WITHDRAW_SUCCESS,
  MIGRATE_DETAILS,
  MIGRATE_SEND,
  MIGRATE_SUCCESS,
  MIGRATE_TIMER,
  MIGRATE_COMPLETED,
  MIGRATE_CHANGE_STATUS,
  STAKE_ERROR,
  RESET_STAKE,
  STAKE_BALANCE,
  STAKE_TIME,
  UNSTAKED_BALANCE,
  UNSTAKE_TIME,
  REWARD_EARNED,
  REWARD_BALANCE,
  HISTORY_SHOW_OM_STAKING,
  LOGOUT,
} from '../actions/action-types';

import { OM_STAKING_MIGRATE_STATUS } from '../constants/blockchain-constants';

// Stake status

// 0 : interest calculator - main

// 1 : stake settings
// 2 : stake details
// 3 : stake sent/pending
// 4 : stake sucessful
// 5 : stake failed

// 20 : unstake settings
// 21 : unstake information
// 22 : unstake details
// 23 : unstake send
// 24 : unstake success

// 30 : claim reward details
// 31 : claim reward send
// 32 : claim reward success

// 40 : withdraw unstaked details
// 41 : withdraw unstaked send
// 42 : withdraw unstaked success

// 50 : migrate details
// 51 : migrate send
// 52 : migrate success
// 53 : migrate timer
// 54 : migrate completed

// 99 : Error

// 100 : history

const DEFAULT_FIELDS = {
  stake: {
    migrateStatus: OM_STAKING_MIGRATE_STATUS.HIDE_POOL,
    status: 0,
    amount: '0',
    id: '',
    stakeTime: '0',
    stakeBalance: '0',
    unstakedBalance: '0',
    unstakedTime: '0',
    rewardEarned: '0',
    rewardBalance: '0',
    omClaimType: 'unstake',
  },
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = _.cloneDeep(DEFAULT_FIELDS), action) => {
  switch (action.type) {
    // STAKE

    case STAKE_SETTINGS:
      return {
        stake: {
          ...state.stake,
          status: 1,
          amount: '0',
        },
      };
    case STAKE_DETAILS:
      return {
        stake: {
          ...state.stake,
          status: 2,
          amount: action.payload.amount,
        },
      };
    case STAKE_SEND:
      return {
        stake: {
          ...state.stake,
          status: 3,
        },
      };
    case STAKE_SUCCESS:
      return {
        stake: {
          ...state.stake,
          id: action.payload.id,
          status: 4,
        },
      };

    // UNSTAKE

    case UNSTAKE_SETTINGS:
      return {
        stake: {
          ...state.stake,
          status: 20,
        },
      };

    case UNSTAKE_INFORMATION:
      return {
        stake: {
          ...state.stake,
          status: 21,
          amount: action.payload.amount,
        },
      };

    case UNSTAKE_DETAILS:
      return {
        stake: {
          ...state.stake,
          status: 22,
        },
      };

    case UNSTAKE_SEND:
      return {
        stake: {
          ...state.stake,
          status: 23,
        },
      };

    case UNSTAKE_SUCCESS:
      return {
        stake: {
          ...state.stake,
          id: action.payload.id,
          status: 24,
        },
      };

    // WITHDRAW UNSTAKED

    case WITHDRAW_DETAILS:
      return {
        stake: {
          ...state.stake,
          status: 40,
        },
      };

    case WITHDRAW_SEND:
      return {
        stake: {
          ...state.stake,
          status: 41,
        },
      };

    case WITHDRAW_SUCCESS:
      return {
        stake: {
          ...state.stake,
          id: action.payload.id,
          status: 42,
        },
      };

    // Migrate

    case MIGRATE_CHANGE_STATUS:
      return {
        stake: {
          ...state.stake,
          migrateStatus: action.payload.migrateStatus,
        },
      };

    case MIGRATE_DETAILS:
      return {
        stake: {
          ...state.stake,
          status: 50,
        },
      };

    case MIGRATE_SEND:
      return {
        stake: {
          ...state.stake,
          status: 51,
        },
      };

    case MIGRATE_SUCCESS:
      return {
        stake: {
          ...state.stake,
          id: action.payload.id,
          status: 52,
        },
      };

    case MIGRATE_TIMER:
      return {
        stake: {
          ...state.stake,
          status: 53,
        },
      };

    case MIGRATE_COMPLETED:
      return {
        stake: {
          ...state.stake,
          status: 54,
        },
      };

    case STAKE_ERROR:
      return {
        stake: {
          ...state.stake,
          status: 99,
        },
      };
    case RESET_STAKE:
      return {
        stake: {
          ...state.stake,
          status: 0,
          amount: '0',
          id: '',
        },
      };
    case HISTORY_SHOW_OM_STAKING:
      return {
        stake: {
          ...state.stake,
          status: 100,
        },
      };
    case STAKE_BALANCE:
      return {
        stake: {
          ...state.stake,
          stakeBalance: action.payload.stakeBalance,
        },
      };
    case STAKE_TIME:
      return {
        stake: {
          ...state.stake,
          stakeTime: action.payload.stakeTime,
        },
      };
    case UNSTAKED_BALANCE:
      return {
        stake: {
          ...state.stake,
          unstakedBalance: action.payload.unstakedBalance,
        },
      };
    case UNSTAKE_TIME:
      return {
        stake: {
          ...state.stake,
          unstakedTime: action.payload.unstakedTime,
        },
      };
    case REWARD_EARNED:
      return {
        stake: {
          ...state.stake,
          rewardEarned: action.payload.rewardEarned,
        },
      };
    case REWARD_BALANCE:
      return {
        stake: {
          ...state.stake,
          rewardBalance: action.payload.rewardBalance,
        },
      };
    case LOGOUT:
      return _.cloneDeep(DEFAULT_FIELDS);
    default:
      return state;
  }
};
